























import { Prop, Component, Vue } from 'vue-property-decorator'
import { UserTarget } from '@/api/model/user-target'
import { UserTargetAPI } from '@/api/backend-client'
import { escapeHtml } from '@/helpers/html'

@Component
export default class TargetsEdit extends Vue {
    @Prop({ required: true }) readonly target: UserTarget|null
    submitting: boolean = false

    async editTarget(): Promise<void> {
        try {
            this.submitting = true

            await UserTargetAPI.update(this.target.id, this.target)
            this.onUpdated(this.target)

        } catch (error) {
            this.$notify({
                type: 'error',
                title: 'Foutmelding',
                text: escapeHtml(error.message),
            })

        } finally {
            this.submitting = false
        }
    }

    onUpdated(target: UserTarget): void {
        this.$emit('updated', target)
    }

    onCancel(): void {
        this.$emit('cancel')
    }
}
